import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { FaEdit } from 'react-icons/fa';
import { AiOutlinePlus } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import {
  Card, CardContent, CardHeader
} from '@mui/material';
import styles from '../../assets/css/TogglerButton.module.css';
import { activatePlan, planListView } from '../../Services/Utils/PlanApis';
import { notifySet } from '../../Services/Actions/CommonActions';
import profileStyles from '../UserDetails/MyProfile.module.css';

function Toggler(props) {
  const dispatch = useDispatch();
  const { planData } = props;
  const [isPlanActive, setIsPlanActive] = useState(planData.active);

  const handllePlanActiveChange = (e, res) => {
    activatePlan({ id: res.id }).then((resp) => {
      const { hasError, message } = resp;
      if (hasError === false) {
        dispatch(notifySet({ type: 'success', message }));
        setIsPlanActive(!isPlanActive);
      } else if (hasError === true) {
        dispatch(notifySet({ type: 'error', message }));
      }
    });
  };
  return (
    <label className={styles.switch}>
      <input
        type="checkbox"
        id="Btn"
        className={`${styles['switch-input']}`}
        checked={isPlanActive}
        onChange={(e) => handllePlanActiveChange(e, planData)}
      />
      <span className={`${styles.slider} ${styles['slider-round']}`} />
    </label>
  );
}

function PlanList() {
  const [plan, setPlan] = useState([]);

  function PlanView() {
    const data = {};
    const params = {
      start: 0,
      recordSize: '',
    };

    planListView(data, params).then((res) => {
      setPlan(res.list);
    });
  }
  useEffect(() => {
    PlanView();
  }, []);

  return (
    <div>
      <div className="title-con">
        <div className="row align-items-center">
          <div className="col-sm-12 col-md-12 col-lg-5">
            <div className="title-left-con">
              <h6>Plans</h6>
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-7">
            <div className="title-right-con list-ul-con">
              <ul>
                <li>
                  <Link className="addcircle" to="/add-plan">
                    <AiOutlinePlus />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        {plan?.map((data) => (
          <Card sx={{ marginTop: '20px' }} key={data.id}>
            <CardHeader
              action={(
                <>
                  <Toggler planData={data} />
                  <Link style={{ marginLeft: '15px' }} to={`/edit-plan/${data.id}`}>
                    <FaEdit style={{ color: 'black', fontSize: '25px' }} />
                  </Link>
                </>
              )}
              title={data.name}
              disableTypography
              sx={{ fontWeight: '500', fontSize: '17px' }}
            />
            <CardContent>
              <div className="tag-btn-title-list-tag">
                {data.serviceProviderViews.length === 0 ? <span className="text-danger">No service partners</span> : ''}
                <div className={`${profileStyles['tag-btn-menu-ul-con']} ${profileStyles.smaller}`}>
                  <ul>
                    {data.serviceProviderViews?.map((deals, Categorykey) => (
                      <li key={Categorykey}>
                        <Link to="#">
                          {deals.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}

export default PlanList;
